module.exports = __webpack_public_path__ + "img/luyuanRuleBg.430c5ef4.png";